import React, { useContext } from 'react';
import {
  Icon,
  SpaceBetween,
  StatusIndicator,
  StatusIndicatorProps,
} from '@cloudscape-design/components';
import { OperatorModalContext } from 'src/context/operatorModalContext';

interface StatusLabelProps {
  loading: boolean;
  label: OperatorJobStatus;
  overrides?: Partial<Record<OperatorJobStatus, Status>>;
}

interface Status {
  label: string;
  type: StatusIndicatorProps.Type;
}
export const StatusLabel = ({
  loading,
  label,
  overrides,
}: StatusLabelProps) => {
  const { setOperatorHelpConfig } = useContext(OperatorModalContext);

  const jobTypeMap: Record<OperatorJobStatus, Status> = Object.assign(
    {
      NOTSTARTED: { label: 'Not Started', type: 'stopped' },
      STARTING: { label: 'Starting', type: 'in-progress' },
      PENDING: { label: 'Pending', type: 'in-progress' },
      SUCCEEDED: { label: 'Succeeded', type: 'success' },
      FAILED: { label: 'Failed', type: 'error' },
      SUCCEEDEDOVERRIDE: { label: 'Succeeded (Override)', type: 'success' },
      SKIPPEDOVERRIDE: { label: 'Skipped (Override)', type: 'warning' },
      FAILEDOVERRIDE: { label: 'Failed (Override)', type: 'error' },
    },
    overrides,
  );

  const showTroubleshootingStatuses = [
    'NOTSTARTED',
    'PENDING',
    'FAILED',
    'FAILEDOVERRIDE',
  ];

  const friendlyStatus: Status = loading
    ? { label: 'Loading', type: 'loading' }
    : jobTypeMap?.[label] || { label: 'Unknown', type: 'stopped' };

  return (
    <SpaceBetween size="m" alignItems="center" direction="horizontal">
      <StatusIndicator type={friendlyStatus.type}>
        {friendlyStatus.label}
      </StatusIndicator>
      {showTroubleshootingStatuses.includes(label) && (
        <>
          <button
            data-testid="help icon"
            className="icon-button"
            onClick={() => {
              return setOperatorHelpConfig({ status: label });
            }}
            title="Troubleshooting"
          >
            <Icon name="support" size="small" />
          </button>
        </>
      )}
    </SpaceBetween>
  );
};
